var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo d-flex align-items-center",attrs:{"to":"/"}},[_c('img',{staticClass:"logo__image",attrs:{"src":"images/logo.png","alt":""}}),_c('div',{staticClass:"logo__text font-weight-bold"},[_vm._v(" Министерство образования Иркутской области ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }